import { useEffect, useState } from "react";
import { useReducedMotion } from "@/hooks/use-reduced-motion";

/** Hidden desktop webviews must settle text, rather than replay it on return. */
export function useAgentTextMotion(): boolean {
  const reduced = useReducedMotion();
  const [visible, setVisible] = useState(
    () => typeof document === "undefined" || !document.hidden,
  );
  useEffect(() => {
    const update = () => setVisible(!document.hidden);
    document.addEventListener("visibilitychange", update);
    return () => document.removeEventListener("visibilitychange", update);
  }, []);
  return !reduced && visible;
}
